export default __webpack_public_path__ + "static/media/feat-airdrop.2eafc932.svg";